import { FC, useMemo } from "react";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import dateService from "../../../../../../../common/utils/date/date.service";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableRow from "../types/order-optimizer-taxi-details-hidden-details-heading-tables-driver-table-row";
import orderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableHelper from "./order-optimizer-taxi-details-hidden-details-heading-tables-driver-table.helper";
import { OrderOptimizerTaxiDetailsItemStepsHomeToStart } from "../../../common/types/order-optimizer-taxi-details-item";

type OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  detailsStepsHomeToStartItem: OrderOptimizerTaxiDetailsItemStepsHomeToStart | null;
};

const OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsHomeToStartItem: OrderOptimizerTaxiDetailsItemStepsHomeToStart
  ): OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableRow => {
    const totalTimeLabel = dateService.formatTime(
      detailsStepsHomeToStartItem.driverTime
    );
    const totalTimeTitle = dateService.formatTime(
      detailsStepsHomeToStartItem.driverTime
    );

    return {
      id: uuidService.generate(),
      value: {
        totalTime: <div title={totalTimeTitle}>{totalTimeLabel}</div>,
        haltingTime: <div title="00:00 h">00:00 h</div>,
        totalDrivingTime: <div title="00:00 h">00:00 h</div>,
        distance: <div title="0.0 KM">0.0 KM</div>,
      },
    };
  };

  const rows: OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableRow[] =
    useMemo(() => {
      if (!props.detailsStepsHomeToStartItem) return [];

      const orderRows = createTableRow(props.detailsStepsHomeToStartItem);

      return [orderRows];
    }, [props.detailsStepsHomeToStartItem, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
    />
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableComponent;
